export const SearchIds = {
    showSearchButton: "showSearchButton",
}

export const ActionTypeIds = [
    "ExecuteScriptAction",
    "ExecuteListScriptAction",
    "ExecuteSelectionScriptAction",
]
